// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"2229053c","109":"663d704f","245":"f3efc1fc","334":"57cb6310","344":"0a5b4288","380":"c54f9081","427":"1fc30a59","565":"97b0e381","587":"8791eaa5","608":"67f779d1","678":"f83cff27","683":"d3bb231e","787":"3f528abd","875":"e4696fcf"}[chunkId] + ".chunk.js";
};